'use client'
import { Swiper, SwiperSlide } from 'swiper/react'
import {
   Navigation,
   Pagination,
   Autoplay,
   EffectCoverflow,
   Keyboard,
} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-coverflow'
import Link from 'next/link'

export default function TemplateSlider() {
   return (
      <div className="slider-column">
         <Swiper
            modules={[
               Navigation,
               Pagination,
               Autoplay,
               EffectCoverflow,
               Keyboard,
            ]}
            autoplay={{
               delay: 3000,
               disableOnInteraction: false,
            }}
            breakpoints={{
               320: { slidesPerView: 1, spaceBetween: 100 },
               640: { slidesPerView: 1, spaceBetween: 200 },
               768: { slidesPerView: 1, spaceBetween: 200 },
               1100: { slidesPerView: 1, spaceBetween: 500 },
            }}
            centeredSlides={true}
            slidesPerView={1}
            loop={true}
            keyboard={{ enabled: true }}
            speed={1000}
            effect="coverflow"
            coverflowEffect={{
               rotate: 0,
               stretch: -10,
               depth: 200,
               modifier: 2,
               slideShadows: true,
            }}
            pagination={{
               el: '.custom-swiper-pagination-template',
               clickable: true,
               renderBullet: (index, className) =>
                  `<span class="${className} custom-bullet"></span>`,
            }}
            navigation={{
               nextEl: '.custom-template-next-btn',
               prevEl: '.custom-template-prev-btn',
            }}
            className="custom-template-slider"
         >
            <SwiperSlide className="custom-slider-component-template-card">
               <div className="story_content section_secondary_bg">
                  <div className="image-section">
                     <img src="/assets/image/slider1.png" />
                  </div>
                  <div className="content-section section_theme_2_bg text-start">
                     <h2>Wedding Planner: Easy Weddings</h2>
                     <p>
                        Easy Wedding transforms the daunting task of wedding
                        planning into an enjoyable experience. Leveraging the
                        trust of 80% of Australian couples, our comprehensive
                        planner and directory bring confidence and control into
                        your hands. From organizing tasks to browsing real
                        weddings for inspiration, we've got you covered.
                     </p>
                     <p className="business-need">Business Needs:</p>
                     <ul className="checklist">
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Streamline wedding planning processes.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Offer a comprehensive budget management tool.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Simplify guest list creation and management.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Provide a centralized platform for wedding
                           milestones.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Create an accessible wedding vendor directory.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Facilitate user reviews for vendor services.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Incorporate a wedding style quiz for personalization.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Showcase real weddings for inspiration and ideas.
                        </li>
                     </ul>
                     <Link
                        className="btn learn-more mt-5"
                        href="/portfolio/wedding-planner"
                     >
                        LEARN MORE
                        <svg
                           width="37"
                           className="img-fluid"
                           height="37"
                           viewBox="0 0 37 37"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip0_5116_214025)">
                              <path
                                 d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                                 fill="#F4F2F0"
                              />
                           </g>
                           <defs>
                              <clippath id="clip0_5116_214025">
                                 <rect
                                    width="36"
                                    height="36"
                                    fill="white"
                                    transform="translate(0.507812 0.324219)"
                                 />
                              </clippath>
                           </defs>
                        </svg>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <SwiperSlide className="custom-slider-component-template-card">
               <div className="story_content section_secondary_bg">
                  <div className="image-section">
                     <img src="/assets/image/slider2.png" />
                  </div>
                  <div className="content-section section_theme_2_bg text-start">
                     <h2>Daily Motivational Quotes App</h2>
                     <p>
                        Beyond just delivering words of encouragement, Enliven
                        offers a truly interactive experience with features like
                        customizable notification timings, effortless social
                        sharing, and personalized content options tailored to
                        individual preferences. The app’s extensive quote
                        library, combined with an engaging and supportive
                        community, fosters a sense of connection and shared
                        inspiration.
                     </p>
                     <p className="business-need">Business Needs:</p>
                     <ul className="checklist">
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Deliver daily motivational quotes to inspire and
                           uplift users.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Provide guided mindfulness and meditation techniques.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Offer a seamless and intuitive user experience.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Enable customizable notifications for personalized
                           motivation.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Integrate a diverse quote library featuring thought
                           leaders and philosophers.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Encourage user interaction through a supportive
                           community.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Allow easy social media sharing for spreading
                           inspiration.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Ensure a balance between free content and premium
                           features.
                        </li>
                     </ul>
                     <Link
                        className="btn learn-more mt-5"
                        href="/portfolio/motivation-quotes"
                     >
                        LEARN MORE
                        <svg
                           width="37"
                           className="img-fluid"
                           height="37"
                           viewBox="0 0 37 37"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip0_5116_214025)">
                              <path
                                 d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                                 fill="#F4F2F0"
                              />
                           </g>
                           <defs>
                              <clippath id="clip0_5116_214025">
                                 <rect
                                    width="36"
                                    height="36"
                                    fill="white"
                                    transform="translate(0.507812 0.324219)"
                                 />
                              </clippath>
                           </defs>
                        </svg>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <SwiperSlide className="custom-slider-component-template-card">
               <div className="story_content section_secondary_bg">
                  <div className="image-section">
                     <img src="/assets/image/slider3.png" />
                  </div>
                  <div className="content-section section_theme_2_bg text-start">
                     <h2>Magic Shoes</h2>
                     <p>
                        Beyond merely monitoring your movements, Tracker's
                        integrated tailored hydration monitor promotes overall
                        health by reminding you to drink enough water throughout
                        the day. The app's advanced analytics, alarms that can
                        be customized, and intuitive interface allow users to
                        easily track a balanced exercise routine.
                     </p>
                     <p className="business-need">Business Needs:</p>
                     <ul className="checklist">
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           A platform that merges physical fitness with digital
                           rewards.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Engaging and motivating workout experiences for
                           users.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Tracking and analytics for workout performance.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           A marketplace for unique digital assets (NFTs).
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Social features to compete and interact with other
                           users.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Scalable technology to support a growing user base.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Integration with blockchain for token earnings and
                           NFT transactions.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           User-friendly design for ease of use across all
                           fitness levels.
                        </li>
                     </ul>
                     <Link
                        className="btn learn-more mt-5"
                        href="/portfolio/magic-shoes"
                     >
                        LEARN MORE
                        <svg
                           width="37"
                           className="img-fluid"
                           height="37"
                           viewBox="0 0 37 37"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip0_5116_214025)">
                              <path
                                 d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                                 fill="#F4F2F0"
                              />
                           </g>
                           <defs>
                              <clippath id="clip0_5116_214025">
                                 <rect
                                    width="36"
                                    height="36"
                                    fill="white"
                                    transform="translate(0.507812 0.324219)"
                                 />
                              </clippath>
                           </defs>
                        </svg>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <SwiperSlide className="custom-slider-component-template-card">
               <div className="story_content section_secondary_bg">
                  <div className="image-section">
                     <img src="/assets/image/slider4.png" />
                  </div>
                  <div className="content-section section_theme_2_bg text-start">
                     <h2>Tracker: Running, Step, Water</h2>
                     <p>
                        Introducing Tracker: Running, Step, Water – a
                        comprehensive mobile application designed by Benzatine
                        Infotech to revolutionize your fitness journey. This app
                        provides an all-in-one solution to accurately and
                        conveniently track and improve your running performance,
                        step count, and hydration levels, regardless of your
                        level of experience.
                     </p>
                     <p className="business-need">Business Needs:</p>
                     <ul className="checklist">
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Real-time tracking of running routes via GPS.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Comprehensive analysis of running performance.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Daily step count monitoring with a pedometer.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Hydration level tracking for optimal health.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Determining heart health and running distance
                           objectives.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Sharing capabilities for routes and achievements.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Detailed records of fitness activities.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Monitoring progress over time to stay motivated.
                        </li>
                     </ul>
                     <Link
                        className="btn learn-more mt-5"
                        href="/portfolio/tracker"
                     >
                        LEARN MORE
                        <svg
                           width="37"
                           className="img-fluid"
                           height="37"
                           viewBox="0 0 37 37"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip0_5116_214025)">
                              <path
                                 d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                                 fill="#F4F2F0"
                              />
                           </g>
                           <defs>
                              <clippath id="clip0_5116_214025">
                                 <rect
                                    width="36"
                                    height="36"
                                    fill="white"
                                    transform="translate(0.507812 0.324219)"
                                 />
                              </clippath>
                           </defs>
                        </svg>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <SwiperSlide className="custom-slider-component-template-card">
               <div className="story_content section_secondary_bg">
                  <div className="image-section">
                     <img src="/assets/image/slider5.png" />
                  </div>
                  <div className="content-section section_theme_2_bg text-start">
                     <h2>Travel Expense Dairy</h2>
                     <p>
                        Travel Expense Dairy is a cutting-edge and intuitive
                        travel budgeting tool that makes managing finances while
                        on the go easier. The app's user-friendly monitoring
                        mechanism ensures total control over trip budgets by
                        assisting users in real-time spending logging, cost
                        classification, and informative report generation. This
                        software is the ideal partner for organizing a weekend
                        break, work trip, or foreign excursion.
                     </p>
                     <p className="business-need">Business Needs:</p>
                     <ul className="checklist">
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Provide an easy-to-use travel expense tracking
                           solution.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Enable real-time logging and categorization of
                           expenses.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Offer multi-currency support for international
                           travelers.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Generate insightful reports for budget planning and
                           financial analysis.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Allow cloud-based backup and synchronization across
                           devices.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Enable users to set budget limits and receive
                           overspending alerts.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Ensure a clean and intuitive interface for effortless
                           financial management.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Balance free and premium features for an optimal user
                           experience.
                        </li>
                     </ul>
                     <Link
                        className="btn learn-more mt-5"
                        href="/portfolio/travel-expense"
                     >
                        LEARN MORE
                        <svg
                           width="37"
                           className="img-fluid"
                           height="37"
                           viewBox="0 0 37 37"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip0_5116_214025)">
                              <path
                                 d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                                 fill="#F4F2F0"
                              />
                           </g>
                           <defs>
                              <clippath id="clip0_5116_214025">
                                 <rect
                                    width="36"
                                    height="36"
                                    fill="white"
                                    transform="translate(0.507812 0.324219)"
                                 />
                              </clippath>
                           </defs>
                        </svg>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <SwiperSlide className="custom-slider-component-template-card">
               {' '}
               <div className="story_content section_secondary_bg">
                  <div className="image-section">
                     <img src="/assets/image/slider6.png" />
                  </div>
                  <div className="content-section section_theme_2_bg text-start">
                     <h2>QR Code Scanner & Barcode Read</h2>
                     <p>
                        QR Scanner Revolution simplifies the process of scanning
                        QR codes and barcodes, supporting all formats including
                        Wi-Fi, contacts, URLs, and more. Features like automatic
                        browser opening for links, instant email access, and
                        VCard contact addition enhance its utility. The app's
                        dedication to privacy is further demonstrated by its
                        capacity to create QR codes for a range of information.
                     </p>
                     <p className="business-need">Business Needs:</p>
                     <ul className="checklist">
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Seamless integration with device cameras to scan
                           directly.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Comprehensive format support for universal
                           application.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           User-friendly interface for effortless operation.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Privacy assurance to foster trust.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           High-speed decoding to enhance user experience.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Scan history and favorites for easy access.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Flashlight support for low-light scanning.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Automatic operation mode to streamline processes.
                        </li>
                     </ul>
                     <Link
                        className="btn learn-more mt-5"
                        href="/portfolio/qr-scanner"
                     >
                        LEARN MORE
                        <svg
                           width="37"
                           className="img-fluid"
                           height="37"
                           viewBox="0 0 37 37"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip0_5116_214025)">
                              <path
                                 d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                                 fill="#F4F2F0"
                              />
                           </g>
                           <defs>
                              <clippath id="clip0_5116_214025">
                                 <rect
                                    width="36"
                                    height="36"
                                    fill="white"
                                    transform="translate(0.507812 0.324219)"
                                 />
                              </clippath>
                           </defs>
                        </svg>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <SwiperSlide className="custom-slider-component-template-card">
               <div className="story_content section_secondary_bg">
                  <div className="image-section">
                     <img src="/assets/image/slider7.png" />
                  </div>
                  <div className="content-section section_theme_2_bg text-start">
                     <h2>Home Workout For Men Women</h2>
                     <p>
                        A complete exercise solution, the Home Workout for Men &
                        Women app was created to make exercising easy,
                        accessible, and efficient. Users can train various
                        muscle groups using a variety of bodyweight exercises
                        that have been scientifically confirmed to work without
                        the need for gym equipment. The app features
                        step-by-step guidance, progress tracking.
                     </p>
                     <p className="business-need">Business Needs:</p>
                     <ul className="checklist">
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Provide structured, effective home workout routines
                           for all fitness levels.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Offer no-equipment exercises for a hassle-free
                           fitness experience.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Deliver AI-powered personalized workout plans based
                           on user goals.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Integrate progress tracking and workout history for
                           motivation.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Ensure a seamless and intuitive user interface for
                           easy navigation.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Include smart workout reminders to maintain
                           consistency.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Support video and animated workout guides for proper
                           form and technique.
                        </li>
                        <li>
                           <img
                              src="/assets/svg/checkmark.svg"
                              alt="Checkmark"
                              className="checkmark"
                           />
                           Offer a balance between free and premium workout
                           plans.
                        </li>
                     </ul>
                     <Link
                        className="btn learn-more mt-5"
                        href="/portfolio/workout"
                     >
                        LEARN MORE
                        <svg
                           width="37"
                           className="img-fluid"
                           height="37"
                           viewBox="0 0 37 37"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip0_5116_214025)">
                              <path
                                 d="M36.2699 17.749L28.0882 9.56725C27.7943 9.22406 27.2778 9.18405 26.9347 9.47803C26.5915 9.77193 26.5515 10.2884 26.8454 10.6316C26.8729 10.6637 26.9026 10.6934 26.9347 10.7208L33.7172 17.5117H1.32595C0.874134 17.5117 0.507812 17.878 0.507812 18.3299C0.507812 18.7818 0.874134 19.148 1.32595 19.148H33.7172L26.9347 25.9306C26.5915 26.2245 26.5515 26.741 26.8454 27.0842C27.1394 27.4274 27.6558 27.4674 27.999 27.1734C28.0311 27.1459 28.0608 27.1162 28.0882 27.0842L36.2699 18.9025C36.5871 18.5835 36.5871 18.0681 36.2699 17.749Z"
                                 fill="#F4F2F0"
                              />
                           </g>
                           <defs>
                              <clippath id="clip0_5116_214025">
                                 <rect
                                    width="36"
                                    height="36"
                                    fill="white"
                                    transform="translate(0.507812 0.324219)"
                                 />
                              </clippath>
                           </defs>
                        </svg>
                     </Link>
                  </div>
               </div>
            </SwiperSlide>
            <div className="d-flex justify-content-center mt-5">
               <button className="custom-template-prev-btn">
                  <img
                     src="/assets/svg/technologies/down-arrow.svg"
                     alt="Prev"
                  />
               </button>
               <div className="d-flex align-items-center justify-content-center template_slider_pagination_parent">
                  <span className="d-flex align-items-center justify-content-center custom-swiper-pagination-template"></span>
               </div>
               <button className="custom-template-next-btn">
                  <img
                     src="/assets/svg/technologies/down-arrow.svg"
                     alt="Next"
                  />
               </button>
            </div>
         </Swiper>
      </div>
   )
}
